import { configureStore } from '@reduxjs/toolkit';
import {applyMiddleware} from 'redux'
import thunk from 'redux-thunk';

import * as reducer from './ducks';

const store = configureStore({ reducer }, applyMiddleware(thunk));

export default store;
